<script setup lang="ts">
import { PropType } from 'vue'

/* Components */
import MainCategoryListItem from '@/components/Main/MainCategoryListItem.vue'
import IconArrowRight from '@/components/Icons/IconArrowRight.vue'
import IconArrowLeft from '@/components/Icons/IconArrowLeft.vue'

/* Types */
import { Category } from '@/types/api/api-v3/category'

const props = defineProps({
  simpleCategories: {
    required: true,
    type: Object as PropType<Category[]>,
  },
})
</script>

<template>
  <nav itemscope itemtype="http://schema.org/SiteNavigationElement">
    <v-slide-group
      :prev-icon="IconArrowLeft"
      :next-icon="IconArrowRight"
      show-arrows
    >
      <main-category-list-item
        v-for="(category, index) in props.simpleCategories"
        :key="index"
        :category="category"
      />
    </v-slide-group>
  </nav>
</template>

<style lang="scss" scoped>
.v-slide-group {
  position: relative;
  display: flex;
  flex: 0 1 auto;
  max-width: 100%;
  height: 112px;
  overflow: unset;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

:deep() {
  .v-slide-group__prev,
  .v-slide-group__next {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 30px;
    height: 100%;

    &--disabled {
      display: none;
    }

    .v-icon:before {
      color: $text-black;
    }
  }

  .v-slide-group__next {
    right: -0;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), white);
  }

  .v-slide-group__prev {
    left: 0;
    background: linear-gradient(90deg, white, rgba(255, 255, 255, 0));
  }
}
</style>
